import {BlockFactory} from "@/models/Blocks/Itens/block-factory";
import {BlockItemType} from '@/models/Blocks/Itens/Types/block-item-type';
import {cloneDeep} from "lodash-es";
import request from '@/Utilities/httpRequest';

export default {
    singleBlockFactory(structData = [], modalKey = null) { // holy shit eureka!
        let parsedBlocks = [];
        structData.forEach((element) => {
            if(element) {
                const item = BlockFactory.get(element);
                if(modalKey && (item.type == BlockItemType.product || item.type == BlockItemType.bundle)){
                    item.blockName = modalKey;
                }
                parsedBlocks.push(item);
            }
        });
        return parsedBlocks;
    },
    socialBlockFactory(structData = [], layoutTemplate = [], perPage = 0, blocksColor = '#333') {
        let parsedBlocks = [];
        if (layoutTemplate && layoutTemplate.length) {
            structData.forEach((element, index) => {
                if (element && index < perPage) {
                    const shape = layoutTemplate[index];
                    let patchedItem = this.formatSocialMedia(element, shape);
                    if (patchedItem) {
                        let b = BlockFactory.get(patchedItem);
                        b.backgroundColor = blocksColor;
                        b.cssClass = shape == 's' ? 'pdp-block-square' : 'pdp-block-vertical';
                        b.blockName = 'PDP_SOCIAL';
                        parsedBlocks.push(b);
                    }
                }
            });
        }
        return parsedBlocks;
    },
    async getModalContent(url, data, modalKey = null){
        let response = await request.post(url, data, true);
        let list = response.data?.list??[];
        return this.singleBlockFactory(list,modalKey);
    },
    formatSocialMedia(item = {}, shape = '') {
        let clone = cloneDeep(item);
        let media = clone.social?.media ?? null;
        if (media && (media[shape] ?? null)) {
            clone.social.images = media[shape].images ?? null;
            clone.social.video = media[shape].video ?? null;
            clone.social.shape = shape;
            return clone;
        }
        return null
    },
};